/**
 * A simple class that shows the instructions for how to use the Editor Map
 * @author Sandra Koo
 */
export class LevelEditorInstructions extends Phaser.Group {
  constructor() {
    super(game);

    this.overlay = this.createOverlay();

    this.container = new Phaser.Group(G.game, this);
    const textInstructions = 'Board Editing Tips:\n' // Add extra tips here. Try to end with a \n so it can be easier to lay out
    + '- You can move the board up and down using your mouse wheel.\n'
    + 'Use this to add gems to the pre-defined drop list\n'
    + '- Delete pre-defined drops by hovering over the column, and pressing BACKSPACE (instead of T).\n'
    + '\n- Click anywhere on the black overlay to close this message.';
    this.instructions = new G.Text(0, 0, textInstructions, 'font-white', 0.5, game.width, null, true, 'center');

    this.container.addChild(this.instructions);

    this.container.x = game.world.bounds.x + game.width / 2;
    this.container.y = game.world.bounds.y + (game.height - (this.instructions.height / 2)) / 2;
  }

  /**
   * create the instructions overlay
   */
  createOverlay() {
    const drawing = new Phaser.Graphics(game); // big overlay
    drawing.beginFill(0, 0.7);
    drawing.drawRect(0, 0, game.width, game.height);
    drawing.inputEnabled = true;
    this.addChild(drawing);

    const overlay = G.makeImage(0, 0, null, 0.5, this);
    overlay.inputEnabled = true;
    overlay.hitArea = new Phaser.Rectangle(-2000, -2000, 4000, 4000); // big hitbox
    overlay.events.onInputDown.add(() => {
      if (this.parent) {
        this.parent.removeChild(this);
      }
      this.destroy();
    });
    return overlay;
  }
}
